import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum ServiceGroupTypeEnum {
    GROUP = 'group',
    SHIFT = 'shift',
    FLOOR = 'floor',
    ROUTE = 'route',
    ROOM = 'room',
}

export const serviceGroupTypeEnumOptions = enumToOptions(
    ServiceGroupTypeEnum,
    'service.settings.group.groupTypes.',
);
